(function () {
  const SHOPPABLE_DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function stripShoppableCloneSlides(swiperEl) {
    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    wrapper.querySelectorAll('.swiper-slide[data-shoppable-clone]').forEach((clone) => clone.remove());
  }

  function emitShoppableSlideChange(section) {
    section.dispatchEvent(new CustomEvent('shoppable-videos:slide-change'));
  }

  function initProductCarousels(root) {
    if (typeof Swiper === 'undefined') return;

    const scope = root || document;

    scope.querySelectorAll('.product-carousel__swiper:not([data-swiper-initialized]):not([data-rss-swiper])').forEach((swiperEl) => {
      const section = swiperEl.closest('.product-carousel, .featured-collection-carousel, .shoppable-videos, .how-to-use, .ingredient-deep-dive, .related-products-carousel, .complete-the-routine, .cart-drawer__routine, .cart-drawer__best-sellers');
      if (!section || section.classList.contains('rss-section')) return;

      const showArrows = section.dataset.showArrows === 'true';
      const showScrollbar = section.dataset.showScrollbar === 'true';
      const nextEl = section.querySelector('.product-carousel__button-next');
      const prevEl = section.querySelector('.product-carousel__button-prev');
      const paginationEl = section.querySelector('.product-carousel__pagination');
      const scrollbarEl = section.querySelector('.swiper-scrollbar');

      swiperEl.dataset.swiperInitialized = 'true';

      const isShoppableVideos = section.classList.contains('shoppable-videos');
      const isCartDrawerCarousel =
        section.classList.contains('cart-drawer__routine') ||
        section.classList.contains('cart-drawer__best-sellers') ||
        Boolean(section.closest('#cart-drawer'));

      if (isShoppableVideos) {
        stripShoppableCloneSlides(swiperEl);
      }

      const shoppableSlideCount = isShoppableVideos
        ? swiperEl.querySelectorAll('.swiper-slide:not([data-shoppable-clone])').length
        : 0;
      const centerShoppable = isShoppableVideos && section.dataset.centeredSlides === 'true';
      const loopShoppable = isShoppableVideos && section.dataset.loop === 'true' && shoppableSlideCount > 1;

      const swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: parseInt(getComputedStyle(section).getPropertyValue('--product-carousel-gap'), 10) || 24,
        grabCursor: true,
        watchOverflow: !loopShoppable,
        centeredSlides: centerShoppable,
        initialSlide: 0,
        loop: loopShoppable,
        nested: isCartDrawerCarousel,
        navigation: showArrows
          ? {
              nextEl,
              prevEl,
            }
          : false,
        pagination: paginationEl
          ? {
              el: paginationEl,
              type: 'bullets',
              clickable: true,
            }
          : false,
        scrollbar: showScrollbar && scrollbarEl
          ? {
              el: scrollbarEl,
              draggable: true,
              hide: false,
            }
          : false,
      };

      if (loopShoppable) {
        swiperOptions.loopedSlides = shoppableSlideCount;
      }

      const swiper = new Swiper(
        swiperEl,
        typeof withIslandSwiperDefaults === 'function'
          ? withIslandSwiperDefaults(swiperOptions)
          : Object.assign({}, swiperOptions, {
              mousewheel: {
                enabled: true,
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
                eventsTarget: 'container',
              },
            })
      );

      swiperEl.productCarouselSwiper = swiper;

      if (isShoppableVideos) {
        const emitSlideChange = () => emitShoppableSlideChange(section);
        swiper.on('slideChange', emitSlideChange);
        swiper.on('realIndexChange', emitSlideChange);
        swiper.on('transitionEnd', emitSlideChange);
        section.dispatchEvent(new CustomEvent('shoppable-videos:ready'));

        if (centerShoppable) {
          swiperEl.addEventListener('click', (event) => {
            const slideEl = event.target.closest('.swiper-slide');
            if (!slideEl || !swiperEl.contains(slideEl)) return;
            if (slideEl.classList.contains('swiper-slide-active')) return;
            if (event.target.closest('.shoppable-video-card__mute')) return;

            event.preventDefault();
            const realIndex = slideEl.dataset.swiperSlideIndex;
            if (realIndex !== undefined && typeof swiper.slideToLoop === 'function') {
              swiper.slideToLoop(parseInt(realIndex, 10));
              return;
            }

            swiper.slideTo(swiper.slides.indexOf(slideEl));
          });
        }
      }
    });
  }

  function destroyProductCarousels(root) {
    const scope = root || document;
 
    scope.querySelectorAll('.product-carousel__swiper[data-swiper-initialized]').forEach((swiperEl) => {
      if (swiperEl.productCarouselSwiper) {
        swiperEl.productCarouselSwiper.destroy(true, true);
        delete swiperEl.productCarouselSwiper;
      }

      swiperEl.querySelectorAll('.swiper-slide[data-shoppable-clone]').forEach((clone) => clone.remove());
      delete swiperEl.dataset.swiperInitialized;
    });
  }

  function bindShoppableBreakpointReinit() {
    if (bindShoppableBreakpointReinit.bound) return;
    bindShoppableBreakpointReinit.bound = true;

    const reinitShoppableVideos = () => {
      document.querySelectorAll('.shoppable-videos').forEach((section) => {
        destroyProductCarousels(section);
        initProductCarousels(section);
      });
    };

    if (SHOPPABLE_DESKTOP_MQ.addEventListener) {
      SHOPPABLE_DESKTOP_MQ.addEventListener('change', reinitShoppableVideos);
    } else {
      SHOPPABLE_DESKTOP_MQ.addListener(reinitShoppableVideos);
    }
  }

  let cartDrawerCarouselReinitTimer = 0;
  let cartDrawerCarouselReiniting = false;
  let cartDrawerCarouselListenersBound = false;
  let cartDrawerCarouselObserver = null;

  function getCartDrawer() {
    return document.querySelector('#cart-drawer');
  }

  function reinitCartDrawerCarousels() {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer || cartDrawerCarouselReiniting) return;

    cartDrawerCarouselReiniting = true;

    try {
      destroyProductCarousels(cartDrawer);
      initProductCarousels(cartDrawer);
    } finally {
      cartDrawerCarouselReiniting = false;
    }
  }

  function scheduleCartDrawerCarouselReinit() {
    clearTimeout(cartDrawerCarouselReinitTimer);
    cartDrawerCarouselReinitTimer = window.setTimeout(() => {
      requestAnimationFrame(reinitCartDrawerCarousels);
    }, 120);
  }

  function cartDrawerAddedUninitializedCarousel(mutations) {
    for (const mutation of mutations) {
      if (mutation.type !== 'childList') continue;

      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        const swiper = node.matches('.product-carousel__swiper')
          ? node
          : node.querySelector?.('.product-carousel__swiper');

        if (swiper && !swiper.dataset.swiperInitialized) {
          return true;
        }
      }
    }

    return false;
  }

  function observeCartDrawerCarousels() {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;

    if (!cartDrawerCarouselObserver) {
      cartDrawerCarouselObserver = new MutationObserver((mutations) => {
        if (cartDrawerCarouselReiniting) return;
        if (!cartDrawerAddedUninitializedCarousel(mutations)) return;
        initProductCarousels(getCartDrawer());
      });
    }

    cartDrawerCarouselObserver.disconnect();
    cartDrawerCarouselObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  function bindCartDrawerCarouselListeners() {
    if (cartDrawerCarouselListenersBound) return;
    cartDrawerCarouselListenersBound = true;

    document.addEventListener('shopify:cart:lines-update', (event) => {
      const settle = () => scheduleCartDrawerCarouselReinit();

      if (event?.promise) {
        event.promise.then(settle).catch(() => {});
        return;
      }

      settle();
    });

    document.addEventListener('cart-drawer:opened', () => {
      scheduleCartDrawerCarouselReinit();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initProductCarousels();
    bindCartDrawerCarouselListeners();
    observeCartDrawerCarousels();
    observeRelatedProductsCarousels();
    bindShoppableBreakpointReinit();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initProductCarousels(event.target);
    observeCartDrawerCarousels();
  });
  document.addEventListener('shopify:block:load', (event) => initProductCarousels(event.target));
  bindCartDrawerCarouselListeners();

  function observeRelatedProductsCarousels() {
    document.querySelectorAll('product-recommendations.related-products-carousel-wrapper:not([data-carousel-observed])').forEach((wrapper) => {
      wrapper.dataset.carouselObserved = 'true';

      const observer = new MutationObserver(() => {
        if (wrapper.dataset.recommendationsPerformed === 'true') {
          queueMicrotask(() => {
            destroyProductCarousels(wrapper);
            initProductCarousels(wrapper);
          });
        }
      });

      observer.observe(wrapper, {
        attributes: true,
        attributeFilter: ['data-recommendations-performed', 'class'],
      });
    });
  }
  document.addEventListener('shopify:section:unload', (event) => destroyProductCarousels(event.target));
})();